jQuery_T4NT(document).ready(function($) {

  /**
   * Variant selection changed
   */
  $(document).on("variant:changed", function(evt) {
    // console.log(evt.currentVariant);
  });

  function fixBalancedMiniCartText() {
    document.querySelectorAll('#t4s-mini_cart .t4s-btn-cart__emty').forEach(function(btn) {
      if (btn.textContent.trim() !== 'FIND YOUR FAVORITES') {
        btn.textContent = 'FIND YOUR FAVORITES';
      }
    });
  }

  function dedupeBalancedPaymentTerms() {
    document.querySelectorAll('.t4s-form__product').forEach(function(form) {
      var terms = [];
      form.querySelectorAll('shopify-payment-terms, .shopify-payment-terms').forEach(function(el) {
        if (terms.indexOf(el) === -1) terms.push(el);
      });
      terms.forEach(function(el, index) {
        if (index > 0) {
          el.style.setProperty('display', 'none', 'important');
          el.setAttribute('aria-hidden', 'true');
        }
      });
    });
  }

  function enhanceBalancedHome() {
    if (!document.body || !document.body.classList.contains('template-index')) return;

    document.querySelectorAll('p, h1, h2, h3, h4, h5, h6').forEach(function(el) {
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (text === 'Yoga Mat Carrying Bag') {
        el.textContent = 'Yoga Mat Bag';
      }
      if (text.indexOf('Stay in the loop on new arrivals and offers') === 0) {
        el.innerHTML = 'Get 10% Off Your First Order<br><span class="bys-newsletter-subline">Join our community for new colors and studio favorites.</span>';
      }
    });

    if (!document.getElementById('bys-home-trust-strip')) {
      var slideshow = document.querySelector('[id$="__1646028739ae283905"]');
      if (slideshow) {
        var strip = document.createElement('section');
        strip.id = 'bys-home-trust-strip';
        strip.className = 'bys-home-trust-strip';
        strip.setAttribute('aria-label', 'Shopping benefits');
        strip.innerHTML = '<div class="bys-home-trust-inner"><div class="bys-home-trust-item"><strong>Ships from North Carolina</strong><span>Packed and shipped directly from our North Carolina location.</span></div><div class="bys-home-trust-item"><strong>Easy Returns</strong><span>Simple returns if your order isn’t the right fit.</span></div><div class="bys-home-trust-item"><strong>Secure Checkout</strong><span>Shop confidently with secure checkout.</span></div></div>';
        slideshow.insertAdjacentElement('afterend', strip);
      }
    }

    if (!document.getElementById('bys-home-cro-styles')) {
      var style = document.createElement('style');
      style.id = 'bys-home-cro-styles';
      style.textContent = '.bys-home-trust-strip{background:#fbf5f5;border-top:1px solid #f0e8e8;border-bottom:1px solid #f0e8e8}.bys-home-trust-inner{max-width:1200px;margin:0 auto;padding:20px 24px;display:grid;grid-template-columns:repeat(3,1fr);gap:28px;text-align:center}.bys-home-trust-item{display:flex;flex-direction:column;gap:4px}.bys-home-trust-item strong{font-size:14px;font-weight:600;color:#293341}.bys-home-trust-item span{font-size:12px;line-height:1.5;color:#666}.bys-newsletter-subline{font-size:18px;font-weight:400;line-height:1.5}@media(max-width:767px){.bys-home-trust-inner{grid-template-columns:1fr;padding:16px 20px;gap:14px}.bys-home-trust-item span{font-size:11px}.bys-newsletter-subline{font-size:15px}}';
      document.head.appendChild(style);
    }
  }

  function balancedSizeLabel(text) {
    var key = (text || '').trim().replace(/^US\s+/i, '').replace(/–/g, '-');
    if (key === '5.5-9.0') return 'US 5.5–9.0';
    if (key === '8.0-11.0') return 'US 8.0–11.0';
    return null;
  }

  function normalizeBalancedSizes() {
    document.querySelectorAll('.t4s-swatch__item[data-value], [data-current-value], .t4s-product-sizes span span').forEach(function(el) {
      var source = el.hasAttribute && el.hasAttribute('data-value') ? el.getAttribute('data-value') : el.textContent;
      var normalized = balancedSizeLabel(source);
      if (normalized && el.textContent.trim() !== normalized) el.textContent = normalized;
    });

    document.querySelectorAll('.t4s-swatch__list').forEach(function(list) {
      var items = Array.prototype.slice.call(list.querySelectorAll(':scope > .t4s-swatch__item[data-value]'));
      var small = items.find(function(el) { return balancedSizeLabel(el.getAttribute('data-value')) === 'US 5.5–9.0'; });
      var large = items.find(function(el) { return balancedSizeLabel(el.getAttribute('data-value')) === 'US 8.0–11.0'; });
      if (small && large && small.nextElementSibling !== large) {
        list.insertBefore(small, large);
        if (small.nextElementSibling !== large) list.insertBefore(large, small.nextElementSibling);
      }
    });
  }

  function addBalancedValueBadges() {
    var handles = [
      'cotton-pilates-grip-socks-3-pack-pink-gray-white',
      'cotton-pilates-grip-socks-3-pack-matcha-black-peach'
    ];
    document.querySelectorAll('.t4s-product').forEach(function(card) {
      var options = card.getAttribute('data-product-options') || '';
      var isValuePack = handles.some(function(handle) { return options.indexOf(handle) !== -1; });
      if (!isValuePack || card.querySelector('.bys-best-value-badge')) return;
      var badgeBox = card.querySelector('.t4s-product-badge');
      if (!badgeBox) return;
      var badge = document.createElement('span');
      badge.className = 't4s-badge-item bys-best-value-badge';
      badge.textContent = 'BEST VALUE · SAVE 32%';
      badgeBox.insertBefore(badge, badgeBox.firstChild);
    });

    if (!document.getElementById('bys-merch-styles')) {
      var style = document.createElement('style');
      style.id = 'bys-merch-styles';
      style.textContent = '.bys-best-value-badge{display:inline-flex!important;align-items:center;justify-content:center;background:#293341!important;color:#fff!important;border-radius:20px!important;padding:5px 9px!important;width:auto!important;height:auto!important;min-width:0!important;min-height:0!important;font-size:10px!important;font-weight:700!important;line-height:1.2!important;letter-spacing:.035em!important;white-space:nowrap!important}.t4s-product-badge:has(.bys-best-value-badge){gap:5px!important}@media(max-width:767px){.bys-best-value-badge{font-size:9px!important;padding:4px 7px!important}}';
      document.head.appendChild(style);
    }
  }

  function fixBalancedEnglishUI() {
    var exactText = {
      'Anasayfa': 'Home',
      'Hakkımızda': 'About Us',
      'Koleksiyonlar': 'Collections',
      'Ürünler': 'Products',
      'İletişim': 'Contact',
      'İletişim Bilgileri': 'Contact Information',
      'Favorilerim': 'Wishlist',
      'Sepetim': 'Cart',
      'Hesabim': 'Account',
      'Menü': 'Menu',
      'Müşteri': 'Customer',
      'Bizi Takip Edin': 'Follow Us',
      'Kaydırmaz Çorap': 'Grip Socks',
      'İstek Listesi': 'Wishlist',
      'Ürünlere gözat': 'Find Your Favorites',
      'Türkiye': 'United States',
      'Bizden ve kampanyalarımızdan haberdar olmak için bültenimize abone olun.': 'Subscribe to our newsletter for new arrivals, studio favorites, and special offers.'
    };

    document.querySelectorAll('a, button, span, p, h1, h2, h3, h4, h5, h6, div, label').forEach(function(el) {
      if (el.children.length) return;
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (exactText[text] && el.textContent !== exactText[text]) {
        el.textContent = exactText[text];
      }
      if (/tüm hakları saklıdır\.?/i.test(text)) {
        el.innerHTML = el.innerHTML.replace(/tüm hakları saklıdır\.?/gi, 'All rights reserved.');
      }
      if (text.indexOf('Tüm ücretler ') === 0) {
        el.textContent = 'All charges are billed in the checkout currency. Your final checkout total will be shown before payment.';
      }
    });

    document.querySelectorAll('a[href*="/pages/hakkimizda"], a[href*="pages/hakkimizda"]').forEach(function(a) {
      a.setAttribute('href', '/pages/about-us');
    });
    document.querySelectorAll('a[href*="/blogs/fashion"]').forEach(function(a) {
      a.setAttribute('href', '/blogs/blog');
    });
    document.querySelectorAll('a[href^="tel:+905343691436"], a[href^="tel:%20+905343691436"]').forEach(function(a) {
      a.setAttribute('href', 'tel:+17045342650');
      var walker = document.createTreeWalker(a, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue && node.nodeValue.indexOf('(+90) 534 369 14 36') !== -1) {
          node.nodeValue = node.nodeValue.replace('(+90) 534 369 14 36', '(704) 534-2650');
        }
      }
    });
  }

  fixBalancedMiniCartText();
  dedupeBalancedPaymentTerms();
  enhanceBalancedHome();
  normalizeBalancedSizes();
  addBalancedValueBadges();
  fixBalancedEnglishUI();

  var observer = new MutationObserver(function() {
    fixBalancedMiniCartText();
    dedupeBalancedPaymentTerms();
    enhanceBalancedHome();
    normalizeBalancedSizes();
    addBalancedValueBadges();
    fixBalancedEnglishUI();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
});
